// extracted by mini-css-extract-plugin
export default {"textAreaField":"TextArea_textAreaField__ddDB3","requiredAsterisk":"TextArea_requiredAsterisk__m9Che"};